export default __webpack_public_path__ + "static/media/placeholder-vertical.0453e47c.jpg";